// src/api/axios.js
import axios from 'axios';

// Dynamic base URL: uses env variable in production, falls back to dev default
const getBaseURL = () => {
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    // Production/Deployment fallback
    const origin = window.location.origin;
    // If we are on a standard port or deployed on cPanel
    return `${origin}/api`;
};

const api = axios.create({
    baseURL: getBaseURL(),
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    withCredentials: false // Bearer Token only — no cookies/CSRF needed
});

// إضافة التوكن لكل طلب
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        // Add current page for tracking (strategic admin feature)
        const path = window.location.pathname;
        config.headers['X-Current-Page'] = path;
        
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// التعامل مع أخطاء المصادقة
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Let the component handle 401 errors (e.g., redirect to login)
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default api;
